import { Button } from '@affine/component';
import { useI18n } from '@affine/i18n';
import { LockIcon } from '@blocksuite/icons/rc';
import { useCallback } from 'react';

import * as styles from './feature-upgrade-nudge.css';

export interface FeatureUpgradeNudgeProps {
  /** Feature title text (caller resolves via useI18n). */
  featureName: string;
  /** Required plan label (e.g. "Team", "Enterprise"). */
  requiredPlan: string;
  /** Optional CTA override. Defaults to generic "Upgrade plan" i18n. */
  ctaText?: string;
  /** Custom upgrade handler. Defaults to navigating to workspace:plans tab. */
  onUpgrade?: () => void;
  /** Optional feature key — reserved for future analytics/telemetry. */
  featureKey?: string;
}

const navigateToPlansTab = () => {
  const url = new URL(window.location.href);
  url.searchParams.set('tab', 'workspace:plans');
  window.location.href = url.toString();
};

export const FeatureUpgradeNudge = ({
  featureName,
  requiredPlan,
  ctaText,
  onUpgrade,
}: FeatureUpgradeNudgeProps) => {
  const t = useI18n();

  const handleClick = useCallback(() => {
    (onUpgrade ?? navigateToPlansTab)();
  }, [onUpgrade]);

  return (
    <div className={styles.root}>
      <LockIcon className={styles.icon} />
      <h3 className={styles.title}>{featureName}</h3>
      <p className={styles.description}>
        {t['com.streamlain.feature-gate.upgrade-description']({
          plan: requiredPlan,
        })}
      </p>
      <Button variant="primary" onClick={handleClick}>
        {ctaText ?? t['com.streamlain.feature-gate.upgrade-cta']()}
      </Button>
    </div>
  );
};
